module.exports = __webpack_public_path__ + "static/media/map.6f9f3998.jpg";